"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var end2end_1 = require("@hudled/end2end");
var firestore_1 = require("firebase/firestore");
var get_1 = __importDefault(require("lodash/fp/get"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var react_redux_firebase_1 = require("react-redux-firebase");
var TabbedStackLayout_1 = __importDefault(require("atomicComponents/organisms/Layout/TabbedStackLayout"));
var LoadingContent_1 = __importDefault(require("components/Spinners/LoadingContent"));
var HudledHelmet_1 = __importDefault(require("containers/App/HudledHelmet"));
var FilteredTable_1 = __importDefault(require("containers/TableMaker/FilteredTable"));
var filter_1 = require("utils/filter");
var hooks_1 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var constants_1 = require("../constants");
var tableConf_1 = require("./tableConf");
var Table = (0, FilteredTable_1.default)(tableConf_1.connectionsTableConf, [(0, filter_1.makeGroupDef)('Connected', function (item) { return (item === null || item === void 0 ? void 0 : item.connectedOn) ? 'Yes' : 'No'; })], [(0, get_1.default)('name'), (0, get_1.default)('customer.name'), function (item) { return (0, end2end_1.getISODate)(item.connectedOn); }]);
var Connections = function () {
    var allRechargedOrganizations = (0, react_redux_1.useSelector)(tableConf_1.connectionsTableConf.config.selector);
    var rechargerCompany = (0, react_redux_1.useSelector)(single_1.selectMyRechargerCompany);
    var onlyPending = (0, hooks_1.useQParam)('onlyPending');
    var _a = __read((0, hooks_1.useSubmitter)('recharger_companies', rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.id, {
        rechargeSetupSteps: (0, firestore_1.arrayUnion)('CONNECT_CLIENT_XEROS'),
    }), 1), setStep = _a[0];
    var filterFn = function (items) { return items === null || items === void 0 ? void 0 : items.filter(function (org) { return org.firstVendorId === 'Xero' && org.matchStatus === 'confirmed' && (!onlyPending || !org.connectedOn); }); };
    var rechargedOrganizations = filterFn(allRechargedOrganizations);
    react_1.default.useEffect(function () {
        var _a;
        if (rechargerCompany && !((_a = rechargerCompany.rechargeSetupSteps) === null || _a === void 0 ? void 0 : _a.includes('CONNECT_CLIENT_XEROS')) && (rechargedOrganizations === null || rechargedOrganizations === void 0 ? void 0 : rechargedOrganizations.length)
            && rechargedOrganizations.length === rechargedOrganizations.filter(function (rO) { return rO.connectedOn; }).length) {
            setStep();
        }
    }, [rechargedOrganizations === null || rechargedOrganizations === void 0 ? void 0 : rechargedOrganizations.length, !rechargerCompany]);
    if (!(0, react_redux_firebase_1.isLoaded)(allRechargedOrganizations)) {
        return (0, jsx_runtime_1.jsx)(LoadingContent_1.default, {});
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HudledHelmet_1.default, { title: "Recharges - Connections", description: "Recharges - Connections" }), (0, jsx_runtime_1.jsx)(TabbedStackLayout_1.default, __assign({ tabs: constants_1.CONNECTIONS_TABS }, { children: (0, jsx_runtime_1.jsx)(Table, { filterFunction: filterFn, width: 745, toolbarProps: { width: 735 } }) }))] }));
};
exports.default = Connections;
